<ion-grid>
  <!--
    display the submission dialog iff:
      - withinLeaderboardSubmissionTime is true
      - leaderboardContext is not yet loaded
      - currentLeaderboardEntry (potential old submission) is empty
      - there's no violation of the submissionPolicy (i.e. it's not a replay of the same puzzle)
      - there's no submit in progress
  -->
  <ng-container
    *ngIf="((leaderboard.withinLeaderboardSubmissionTime$|async) && (leaderboard.leaderboardContext$|async) === undefined && (leaderboard.currentLeaderboardEntry$|async) === undefined && (leaderboard.submissionPolicyViolation$ | async) === undefined) && submitInProgress === false">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <span *ngIf="(leaderboard.strictRulesActive$ | async)">
            {{ "PUZZLE.leaderboard_win_dialog.message_strict" | translate }}
          </span>
          <span *ngIf="!(leaderboard.strictRulesActive$ | async)">
            {{ "PUZZLE.leaderboard_win_dialog.message_relaxed" | translate }}
          </span>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
          <ion-item lines="none" class="input">
            <ion-input
              class="ion-align-self-end"
              id="nameInput"
              #nameInput="ngModel"
              [(ngModel)]="nickname"
              libLeaderboardNicknameValidator="2,25"
              enterkeyhint="send"
              (keyup.enter)="sendToLeaderboard()"
              labelPlacement="floating"
              [helperText]="
                nicknameIsSeeded()
                ? ('PUZZLE.leaderboard_win_dialog.name_change' | translate)
                : ('PUZZLE.leaderboard_win_dialog.public_warning' | translate)
              "
              [label]="'PUZZLE.leaderboard_win_dialog.nickname_input' | translate"
              [placeholder]="'PUZZLE.leaderboard_win_dialog.nickname_placeholder' | translate"
              [errorText]="getErrorText(nameInput.errors) | translate"
              (ngModelChange)="nameInput.control.markAsTouched()"
            />
            <ion-buttons slot="end">
              <ion-button
                #submitbutton
                color="primary"
                (click)="sendToLeaderboard()"
                fill="solid"
                [disabled]="nameInput?.errors || !this.nickname"
              >
                {{ "PUZZLE.leaderboard_win_dialog.send_button" | translate }}
                <ion-icon slot="end" name="send-sharp" />
              </ion-button>
              </ion-buttons>
          </ion-item>
      </ion-col>
    </ion-row>
  </ng-container>
  <!--
    display the reason why the user is not allowed to submit to leaderboard if the puzzle would still be within the submission timeframe
  -->
  <ion-row
    *ngIf="((leaderboard.withinLeaderboardSubmissionTime$|async) && (leaderboard.leaderboardContext$|async) === undefined && (leaderboard.currentLeaderboardEntry$|async) === undefined && (leaderboard.submissionPolicyViolation$ | async) !== undefined)">
    <ion-col>
      <p>{{ "PUZZLE.leaderboard_win_dialog.submission_policy_violation." + (leaderboard.submissionPolicyViolation$ | async) | translate }}</p>
    </ion-col>
  </ion-row>
  <ion-row
    *ngIf="(!(leaderboard.withinLeaderboardSubmissionTime$|async) && (leaderboard.leaderboardContext$|async) === undefined && (leaderboard.currentLeaderboardEntry$|async) === undefined)">
    <ion-col>
      <p>{{ "PUZZLE.leaderboard_win_dialog.submission_policy_violation.old_puzzle" | translate }}</p>
    </ion-col>
  </ion-row>
  <!--
    display the spinner if
     - there's a submission in progress, or
     - if there's a submitted entry, but it's context wasn't loaded yet
     - TODO when loading
  -->
  <ion-row
    *ngIf="((leaderboard.leaderboardContext$|async) === undefined && (leaderboard.currentLeaderboardEntry$|async) !== undefined) || submitInProgress">
    <ion-col class="spinner">
      <ion-spinner name="circular" />
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <!--
        display a context variant of the leaderboard if
          - leaderboardContext finished loading and
          - currentLeaderboardEntry is set (the submitted entry)
      -->
      <lib-app-leaderboard-tabs
        withMode="my_context"
        *ngIf="((leaderboard.leaderboardContext$|async) !== undefined && (leaderboard.currentLeaderboardEntry$|async) !== undefined)"
      />

      <!--
        display generic leaderboard if either:
          - user did not submit a leaderboard and
          - user violated submission policy somehow and won't be shown the form
      -->
      <lib-app-leaderboard-tabs
        *ngIf="(leaderboard.currentLeaderboardEntry$|async) === undefined && ((leaderboard.submissionPolicyViolation$ | async) !== undefined || !(leaderboard.withinLeaderboardSubmissionTime$|async))"
      />

    </ion-col>
  </ion-row>
</ion-grid>
